import {Global} from '../utilities/global';
import {GlobalVariableService} from '../../common/variables/global-variable';
import {SC_Input} from '../input/SC_Input';
import * as _ from 'lodash';
import {RoofShape} from '../roof/RoofShape';
import {Sol50OnRoof} from '../mountsys/Sol50OnRoof';
import {ModList} from '../panel/ModList';
import {MountingSystem} from '../mountsys/MountingSystem';
import {SC_Beam} from '../roof/SC_Beam';
import {ModulProp} from '../panel/ModulProp';
import {ScaleAdjustmentValue} from '../getScaleFactor';
import {Point} from '../area/Point';
import {DrawRoofForPanel} from '../panel/drawRoofForPanel';
import {AreaFinder} from '../roof/areaFinder';

export class Statics {

    public static sDebug: string;
    public static oSnowPressure: any = {};
    public static oWindLoad: any = {};
    public static oPressureTotal: any = {};
    public static oSuction: any = {};
    public static oSpanWidthMax: any;
    public static nSpanWidthMax: number;//in cm
    //cantilever
    public static oCantileverMin: any; //in cm
    public static oCantileverMax: any; //Object;//in cm
    public static oVerticalCantileverMax: any;//in cm
    //max cantilever factor
    public static CANTILEVER_MAX_FACTOR: number = 0.45;
    // statics values
    private static oStatics: any;
    // statics roof area
    public static sCurrentArea: string = 'h';
    // invalid solar panels
    public static iInvalid: number;
    // flag the existance of invalid solar panels
    public static bBadModulesExist: boolean;
    private static fnStaticHandler: Function;
    private static sCurrentHProfile: string;

    public static initStatics(sHProfile: string): void {
        if (MountingSystem.hasStatics()) {
            //set current component
            SC_Input.sHProfile = sHProfile;
            this.sCurrentHProfile = sHProfile;
            //init vars
            MountingSystem.updateHProfileVar(sHProfile);
        }
        this.oSpanWidthMax = {};
        this.oCantileverMax = {};
        this.oCantileverMin = {};
        this.oVerticalCantileverMax = {};
        this.bBadModulesExist = false;
        this.iInvalid = 0;
        this.sCurrentArea = 'f';
        this.berechneUSPWMax();
        this.sCurrentArea = 'g';
        this.berechneUSPWMax();
        this.sCurrentArea = 'h';
        this.berechneUSPWMax();
        //Änderung
        // MountingSystem.Groups_change();
    }


    // Calculate E/10 roof area
    static getE10(nLen: number, nBuildingHeight: number): number {
        if (nLen < nBuildingHeight * 2) {
            return nLen / 10;
        } else {
            return (nBuildingHeight * 2) / 10;
        }
    }

    // Calculate E/4 roof area
    static getE4(nLen: number, nBuildingHeight: number): number {
        if (nLen < nBuildingHeight * 2) {
            return nLen / 4;
        } else {
            return (nBuildingHeight * 2) / 4;
        }
    }

    // Calculate Scale factor for X and Y co-ordinates for Canvas
    static getScaleForCanvas() {
        var noOfCellsPerX = Global.canRoof.noOfCellsPerX;
        var noOfCellsPerY = Global.canRoof.noOfCellsPerY;
        var stepX = parseInt((SC_Input.b / noOfCellsPerX).toFixed());
        var stepY = parseInt(((SC_Input.iRoofShape != 4 ? SC_Input.a : SC_Input.a + SC_Input.d) / noOfCellsPerY).toFixed());
        while (!this.numberIsMultiplesOfFive(stepX)) {
            stepX++;
        }
        while (!this.numberIsMultiplesOfFive(stepY)) {
            stepY++;
        }

        Global.canRoof.scaleX = 50 / stepX;
        Global.canRoof.scaleY = 50 / stepY;
        Global.canRoof.stepX = stepX;
        Global.canRoof.stepY = stepY;
    }

    static numberIsMultiplesOfFive(num: number): boolean {
        return num % 50 == 0;
    }

    // Calculate characteristic snow load (Sk)
    public static calculateSk(snowZone: string, terrainHeight: number): number {
        var result: number = 0;
        switch (snowZone) {
            case '1':
                result = 0.19 + (0.91 * Math.pow(((terrainHeight + 140) / 760), 2));
                break;
            case '1a':
                result = (0.19 + (0.91 * Math.pow(((terrainHeight + 140) / 760), 2))) * 1.25;
                break;
            case '2':
                result = 0.25 + (1.91 * Math.pow(((terrainHeight + 140) / 760), 2));
                break;
            case '2a':
                result = (0.25 + (1.91 * Math.pow(((terrainHeight + 140) / 760), 2))) * 1.25;
                break;
            case '3':
                result = 0.31 + (2.91 * Math.pow(((terrainHeight + 140) / 760), 2));
                break;
        }
        return result;
    }

    // Calculates the snow load coefficient according to the minimum values
    public static calculateSnowLoadCoefficient(snowZone: string, terrainHeight: number, oSnowLoadData: any): number {
        var result: number = 0;
        switch (snowZone) {
            case '1':
            case '1a':
                if (terrainHeight <= 400) {
                    result = oSnowLoadData[snowZone];
                }
                break;
            case '2':
            case '2a':
            case '3':
                if (terrainHeight <= 285) {
                    result = oSnowLoadData[snowZone];
                }
                break;
        }
        return result;
    }

    // Calculates the roof pitch coefficient µ (Müh)
    public static calculateRoofPitchCoefficient(roofAngle: number): number {
        var result: number;
        roofAngle = (roofAngle);  //number(roofAngle);
        if (roofAngle <= 30) {
            result = 0.8;
        } else {
            result = 0.8 * (60 - roofAngle) / 30;
        }
        return result;
    }

    // Calculate Si
    public static calculateSi(snowZone: string, terrainHeight: number, sl: Object, roofAngle: number): number {
        var result: number;
        var sk1: number = this.calculateSk(snowZone, terrainHeight);
        var sk2: number = this.calculateSnowLoadCoefficient(snowZone, terrainHeight, sl);
        if (sk1 > sk2) {
            result = sk1;
        } else {
            result = sk2;
        }
        result = result * this.calculateRoofPitchCoefficient(roofAngle);
        this.oSnowPressure[this.sCurrentArea] = result;
        return result;
    }

    // Calculate wind pressure We
    public static calculateWe(windZone: string, buildingHeight: string, terrainCategory: string, roofAngle: string, oSuctionData: any, cpe: any): number {
        var result: number = 0;
        var qze: number = oSuctionData[windZone][parseInt(terrainCategory)][buildingHeight];
        result = qze * cpe[roofAngle][this.sCurrentArea + 'Pressure'];
        return result;
    }

    // Calculate total pressure
    public static calculateTotalPressure(Si: number): number {
        var We: number = this.calculateWe(SC_Input.sWindzone, SC_Input.iBuilding.toString(), SC_Input.sTerrainCat.toString(), SC_Input.iRoofAngle.toString(), this.oStatics.suction, this.oStatics.cpe);
        this.oWindLoad[this.sCurrentArea] = We;
        var pressure1: number = Si + (0.6 * We);
        var pressure2: number = We + (0.5 * Si);
        var result: number;
        if (pressure1 > pressure2) {
            result = pressure1;
        } else {
            result = pressure2;
        }
        return result;
    }

    // Calculate We suction
    public static calculateWeSuction(windZone: string, buildingHeight: string, terrain: string, roofAngle: string, suctionData: any, cpe: any): number {
        var qze: number = suctionData[windZone][parseInt(terrain)][buildingHeight];
        var result: number = qze * cpe[roofAngle][this.sCurrentArea + 'Suction'];
        return result;
    }

    // Calculate maximum span width
    private static CalcUspWmax(_nBeamDist: number, _nSi: number, _nWind: number, oSpanWidthData: any): number {
        var nPressure: number;
        var nSuction: number;
        var nPressure2: number;
        var nSuction2: number;
        var iReturn: number = 0;
        // Space in mm
        var sVerticalSpaceMM: string;
        var nModHeight: number;
        var nModWidth: number;
        var nBeamDistMM: number = _nBeamDist * 10;
        this.oSpanWidthMax[this.sCurrentArea] = new Object();
        this.oCantileverMin[this.sCurrentArea] = new Object();
        this.oCantileverMax[this.sCurrentArea] = new Object();
        nModHeight = SC_Input.nModHeight / 10;
        nModWidth = SC_Input.nModWidth / 10;
        //Für Modulhöhe  -- For module height
        sVerticalSpaceMM = this.optimizeVerticalSpace(nModWidth * 10);
        nPressure = oSpanWidthData[sVerticalSpaceMM]['pressure' + this.optimizeBeamDist(nBeamDistMM).toString() + 'mm'];
        nSuction = oSpanWidthData[sVerticalSpaceMM]['suction' + this.optimizeBeamDist(nBeamDistMM).toString() + 'mm'];
        // wenn Druck und Sogwerte innerhalb der Toleranz
        // if pressure and suction values ​​are within tolerance
        if ((nPressure > _nSi) && (nSuction < _nWind)) {
            // testen ob auch der doppelte Sparrenabstand funktioniert
            //  test whether the double rafter spacing also works
            iReturn = _nBeamDist * 2;
            if (iReturn >= 200) {
                iReturn = iReturn / 2;
            }
            nPressure2 = oSpanWidthData[sVerticalSpaceMM]['pressure' + this.optimizeBeamDist(iReturn * 10).toString() + 'mm'];
            nSuction2 = oSpanWidthData[sVerticalSpaceMM]['suction' + this.optimizeBeamDist(iReturn * 10).toString() + 'mm'];
            // wenn nein, dann Sparrenabstand wieder halbieren
            if ((nPressure2 < _nSi) || (nSuction2 > _nWind)) {
                iReturn = iReturn / 2;
            } else {
                nPressure = nPressure2;
                nSuction = nSuction2;
            }
            //no lower limit needed
            this.oCantileverMin[this.sCurrentArea][nModHeight.toString()] = 0;
            this.oCantileverMax[this.sCurrentArea][nModHeight.toString()] = Math.ceil((this.CANTILEVER_MAX_FACTOR * iReturn));
        } else {
            // der vorhanden Sparrenabstand reicht nicht um Druck / Sogwerte aufzunehmen
            iReturn = -1;
            this.oCantileverMin[this.sCurrentArea][nModHeight.toString()] = iReturn;
            this.oCantileverMax[this.sCurrentArea][nModHeight.toString()] = iReturn;
        }
        this.oSpanWidthMax[this.sCurrentArea][nModHeight.toString()] = iReturn;
        //Für Modulbreite
        sVerticalSpaceMM = this.optimizeVerticalSpace(nModHeight * 10);
        nPressure = oSpanWidthData[sVerticalSpaceMM]['pressure' + this.optimizeBeamDist(nBeamDistMM).toString() + 'mm'];
        nSuction = oSpanWidthData[sVerticalSpaceMM]['suction' + this.optimizeBeamDist(nBeamDistMM).toString() + 'mm'];
        // wenn Druck und Sogwerte innerhalb der Toleranz
        if ((nPressure > _nSi) && (nSuction < _nWind)) {
            // testen ob auch der doppelte Sparrenabstand funktioniert
            iReturn = _nBeamDist * 2;
            if (iReturn >= 200) {
                iReturn = iReturn / 2;
            }
            nPressure2 = oSpanWidthData[sVerticalSpaceMM]['pressure' + this.optimizeBeamDist(iReturn * 10).toString() + 'mm'];
            nSuction2 = oSpanWidthData[sVerticalSpaceMM]['suction' + this.optimizeBeamDist(iReturn * 10).toString() + 'mm'];
            // wenn nein, dann Sparrenabstand wieder halbieren
            if ((nPressure2 < _nSi) || (nSuction2 > _nWind)) {
                iReturn = iReturn / 2;
            } else {
                nPressure = nPressure2;
                nSuction = nSuction2;
            }
            //kein kragarm min nötig
            this.oCantileverMin[this.sCurrentArea][nModWidth.toString()] = 0;
            this.oCantileverMax[this.sCurrentArea][nModWidth.toString()] = Math.ceil((this.CANTILEVER_MAX_FACTOR * iReturn));
        } else {
            // der vorhanden Sparrenabstand reicht nicht um Druck / Sogwerte aufzunehmen
            iReturn = -1;
            this.oCantileverMin[this.sCurrentArea][nModWidth.toString()] = iReturn;
            this.oCantileverMax[this.sCurrentArea][nModWidth.toString()] = iReturn;
        }
        this.oSpanWidthMax[this.sCurrentArea][nModWidth.toString()] = iReturn;
        return iReturn;
    }


    private static Purlin_CalcUspWmax(_nSi: number, _nWind: number, _oSpanWeit: any): number {
        var nDruck: number;
        var nZug: number;
        var iRet: number = 0;
        var nModHeight: number;
        var nModWidth: number;
        var aDist: number[];
        var i: number;
        var sVerticalSpaceMM: string;
        aDist = [500, 600, 700, 800, 900, 1000, 1200, 1400, 1600, 1800];
        this.oSpanWidthMax[this.sCurrentArea] = new Object();
        this.oVerticalCantileverMax[this.sCurrentArea] = new Object();
        nModHeight = SC_Input.nModHeight / 10;
        nModWidth = SC_Input.nModWidth / 10;
        sVerticalSpaceMM = this.optimizeVerticalSpace(nModHeight * 10);
        for (i = 0; i < aDist.length; i++) {
            nDruck = _oSpanWeit[sVerticalSpaceMM]['pressure' + aDist[i].toString() + 'mm'];
            nZug = _oSpanWeit[sVerticalSpaceMM]['suction' + aDist[i].toString() + 'mm'];
            if ((nDruck > _nSi) && (nZug < _nWind)) {
                iRet = aDist[i] / 10;
            } else {
                break;
            }
        }
        if (i == 0) {
            iRet = -1;
        }
        this.oSpanWidthMax[this.sCurrentArea][nModHeight.toString()] = iRet;
        sVerticalSpaceMM = this.optimizeVerticalSpace(nModWidth * 10);
        for (i = 0; i < aDist.length; i++) {
            nDruck = _oSpanWeit[sVerticalSpaceMM]['pressure' + aDist[i].toString() + 'mm'];
            nZug = _oSpanWeit[sVerticalSpaceMM]['suction' + aDist[i].toString() + 'mm'];
            if ((nDruck > _nSi) && (nZug < _nWind)) {
                iRet = aDist[i] / 10;
            } else {
                break;
            }
        }
        if (i == 0) {
            iRet = -1;
        }
        this.oSpanWidthMax[this.sCurrentArea][nModWidth.toString()] = iRet;
        this.oVerticalCantileverMax[this.sCurrentArea] = 30;
        return iRet;
    }

    /**
     * Use database known beam distances
     * @param _nDist Distance in mm
     * @return
     *
     */
    private static optimizeBeamDist(_nDist: number): number {
        if (_nDist < 500) {
            _nDist = 500;
        }
        if (_nDist >= 200 && _nDist <= 1000) {
            return Math.round(_nDist / 100) * 100;
        } else if (_nDist > 1000 && _nDist <= 2000) {
            return Math.round(_nDist / 200) * 200;
        }
        return _nDist;
    }

    /**
     * Use database known vertical spaces
     * @param _nSpace Space in mm
     * @return
     *
     */
    private static optimizeVerticalSpace(_nSpace: number): string {
        var sRet: string;
        if (_nSpace <= 810) {
            sRet = '810';
        } else if (_nSpace <= 994) {
            sRet = '994';
        } else if (_nSpace <= 1129) {
            sRet = '1129';
        } else if (_nSpace <= 1318) {
            sRet = '1318';
        } else if (_nSpace <= 1409) {
            sRet = '1409';
        } else if (_nSpace <= 1685) {
            sRet = '1685';
        } else if (_nSpace <= 1750) {
            sRet = '1750';
        } else if (_nSpace <= 1800) {
            sRet = '1800';
        } else if (_nSpace <= 2300) {
            sRet = '2300';
        } else {
            sRet = '1685';
        }
        sRet = _nSpace.toString();
        return sRet;
    }

    public static berechneUSPWMax(): boolean {
        this.sDebug = '';
        var nSi: number = this.calculateTotalPressure(this.calculateSi(SC_Input.sSchneezone, SC_Input.iTerrain, this.oStatics.snowLoad, SC_Input.iRoofAngle));
        var nWind: number = this.calculateWeSuction(SC_Input.sWindzone, (SC_Input.iBuilding).toString(), SC_Input.sTerrainCat.toString(), SC_Input.iRoofAngle.toString(), this.oStatics.suction, this.oStatics.cpe);
        this.oPressureTotal[this.sCurrentArea] = nSi;
        this.oSuction[this.sCurrentArea] = nWind;
        if (MountingSystem.hasStatics()) {
            if (SC_Input.iBeamType == SC_Beam.PURLIN) {
                this.nSpanWidthMax = this.Purlin_CalcUspWmax(nSi, nWind, this.oStatics.fastener[this.sCurrentHProfile]);
            } else {
                this.nSpanWidthMax = this.CalcUspWmax(SC_Input.nBeamDist, nSi, nWind, this.oStatics.fastener[this.sCurrentHProfile]);
            }
            if (this.nSpanWidthMax < 0) {
                return false;
            }
        }
        return true;
    }

    // Process statics data from server
    public static StaticsHandler(result: any): void {
        var sProfile: string;
        this.oStatics = result;
        if (SC_Input.sHProfile == '') {
            // Set default to 2nd profile
            sProfile = GlobalVariableService.aHProfiles[1];
        } else {
            sProfile = SC_Input.sHProfile;
        }
        this.initStatics(sProfile);
        // Global.pageTools.updatePriceOptInfo();
        if (this.fnStaticHandler !== null) {
            this.fnStaticHandler();
        }
    }


    public static getRow(aMod: number[], iStart: number) {
    }

    public static getHGroupSOL50(aMod: number[], iStart: number) {
    }

    public static getVGroup(aMod: number[], iStart: number) {
    }

    public static PLANABLE_YES: number = 1;
    public static PLANABLE_NO: number = 2;

    //
    public static getPlanable(): number {
        var iResult: number = 0;
        if (Statics.oPressureTotal['f'] > 5.4 || Statics.oPressureTotal['g'] > 5.4 || Statics.oPressureTotal['h'] > 5.4) {
            iResult = this.PLANABLE_NO;
        } else {
            iResult = this.PLANABLE_YES;
        }
        return iResult;
    }

    public static checkCantileverSOL50(): boolean {
        if (!SC_Input.bBeam) {
            return true;
        } else if (SC_Input.iBeamType == SC_Beam.PURLIN) {
            this.clearKragarm();
            return this.checkVKragarm();
        }
        let rowvalueYs: any[] = []; // no of groups or rows
        this.clearKragarm();
        for (let i = 0; i < ModList.listOfGroups.length; i++) {
            let panelRow = ModList.listOfGroups[i];
            if (ModList.listOfGroups[i + 1]) {
                // check if landscape (width > height of panel)
                if (panelRow[0].y == ModList.listOfGroups[i + 1][0].y && (panelRow[0].width > panelRow[0].height)) {
                    // console.log('each panel row2 same row',panelRow[panelRow.length - 1].x,ModList.listOfGroups[i+1][0].x);
                    Array.prototype.push.apply(panelRow, ModList.listOfGroups[i + 1]); // push second array to first array
                    i = i + 1; // skip next list
                }
            }

            let sortedRow = _.sortBy(panelRow, 'x');
            // console.log('each panel row2',sortedRow);
            this.checkHGroup(sortedRow);
        }

        return true;
    }


    static checkVKragarm(): boolean {
        const scaleGap = 100; // cm
        var iInvalid = 0;
        var nRoofHeight = RoofShape.getCurrentRoofHeight();
        var nLastBeam = nRoofHeight - ((nRoofHeight - SC_Input.nBeamDist2) % SC_Input.nBeamDist) + scaleGap;
        var sRange;
        var oVerticalCantileverMax: any = Statics.oVerticalCantileverMax;
        ModList.listOfGroups.forEach((panelrow: any) => {
            panelrow.forEach((panel: any) => {
                //top
                var nCantilever = SC_Input.nBeamDist2 + scaleGap - (panel.y - Sol50OnRoof.nRandTop);
                if (nCantilever > 0) {
                    sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(panel) : 'h';
                    if (nCantilever > oVerticalCantileverMax[sRange]) {
                        panel.iCantilever = ModulProp.CANTILEVER_ON;
                        this.drawKragarm(panel.id);
                        iInvalid++;
                    }
                }
                //bottom
                nCantilever = ((panel.y + panel.height) + Sol50OnRoof.nRandTop) - nLastBeam;
                if (nCantilever > 0) {
                    sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(panel) : 'h';
                    if (nCantilever > oVerticalCantileverMax[sRange]) {
                        iInvalid++;
                        panel.iCantilever = ModulProp.CANTILEVER_ON;
                        this.drawKragarm(panel.id);
                    }
                }
            });
        });
        return iInvalid <= 0;
    }

    static checkHGroup(panelRow: any[]): boolean {
        // console.log("checkHGroup");
        var nXDif: number, nX: number, nCnt: number;
        var oModFirst: any;
        var oModLast: any;
        var i: number, j: number, k: number;
        var sModWidth: string;
        var sRange: string;
        var iInvalid: number = 0;
        sModWidth = panelRow[0].width.toString();
        // console.log(panelRow)
        var oCantileverMax: any = Statics.oCantileverMax;  //{ 'H': { 'potrait': 30 } };
        var oCantileverMin: any = Statics.oCantileverMin;  // { 'H': { 'potrait': 0 } };
        sModWidth = panelRow[0].width.toString();
        //from left
        for (i = 0; i < panelRow.length; i++) {
            oModFirst = panelRow[i];
            // console.log(DrawRoofForPanel.stage.find("#" + oModFirst.panelId));
            sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(oModFirst) : 'h';
            nX = oModFirst.x - SC_Input.nBeamDist1 - 100;
            if (nX < 0) {
                nCnt = 0;
            } else {
                nCnt = Math.ceil(nX / SC_Input.nBeamDist);
            }
            nXDif = Math.abs(nX - (nCnt * SC_Input.nBeamDist));
            if (nXDif > oCantileverMax[sRange][sModWidth] || nXDif < oCantileverMin[sRange][sModWidth]) {
                iInvalid++;
                oModFirst.iCantilever = ModulProp.CANTILEVER_ON;
                // oModFirst.drawKragarm();
                this.drawKragarm(oModFirst.id);
            } else {
                //valid
                break;
            }
        }
        //from right
        for (j = panelRow.length - 1; j >= 0; j--) {
            oModLast = panelRow[j];
            sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(oModLast) : 'h';
            nX = (oModLast.x + oModLast.width) - SC_Input.nBeamDist1 - 100;

            nCnt = Math.floor(nX / SC_Input.nBeamDist);

            nXDif = nX - (nCnt * SC_Input.nBeamDist);
            // console.log('cantilever check check 2', sRange, nX, nCnt, nXDif, oModLast, oCantileverMax, oCantileverMin);
            if (nXDif > oCantileverMax[sRange][sModWidth] || nXDif < oCantileverMin[sRange][sModWidth]) {
                // console.log('cantilever check check 3', sRange, nX, nCnt, nXDif, oModLast, oCantileverMax, oCantileverMin);
                iInvalid++;
                oModLast.iCantilever = ModulProp.CANTILEVER_ON;
                // oModLast.drawKragarm();
                this.drawKragarm(oModLast.id);

            } else {
                // valid
                break;
            }
        }
        // If found a valid group - Mind. 2 Sparren-Check
        let nGroupWidth: number;
        if (j - i > -1) {
            oModFirst = panelRow[i];
            oModLast = panelRow[j];
            // console.log(AreaFinder.getAreaByModule(DrawRoofForPanel.stage.find("#" + oModFirst.panelId))[0]);
            // Modulgruppe muss auf 2 Sparren liegen
            nGroupWidth = (oModLast.width + oModLast.x) - oModFirst.x;
            if (nGroupWidth > SC_Input.nBeamDist * 2) {

            } else {
                nX = oModFirst.x - SC_Input.nBeamDist1 - 100;
                nCnt = Math.ceil(nX / SC_Input.nBeamDist);
                nXDif = (nCnt * SC_Input.nBeamDist) - nX;
                if ((nGroupWidth - nXDif) / SC_Input.nBeamDist < 1) {
                    for (k = i; k <= j; k++) {
                        iInvalid++;
                        oModFirst = panelRow[k];
                        oModFirst.iCantilever = ModulProp.CANTILEVER_ON;
                        // oModFirst.drawKragarm();
                        this.drawKragarm(oModFirst.id);
                    }
                }
            }
        }
        return iInvalid <= 0;
    }

    static drawKragarm(name: any): void {
        const panel: any = (DrawRoofForPanel.stage.find('#' + name));
        let a = panel[0].find('.canTilEver')[0];
        a.opacity(1);
        DrawRoofForPanel.layerPanel.batchDraw();
    }

    static clearKragarm(): void {
        // console.log("clear Panel")
        let all: any = DrawRoofForPanel.stage.find('.canTilEver');
        all.forEach((a: any) => {
            a.opacity(0);
        });
        // DrawRoofForPanel.layerPanel.batchDraw();
    }

    static isModuleInRange(p: number, q: number, topLeft: Point, topRight: Point, bottomLeft: Point, bottomRight: Point): boolean {
        if (p >= ScaleAdjustmentValue.getScaleAdjust(topLeft.x) && p <= ScaleAdjustmentValue.getScaleAdjust(topRight.x) && q >= ScaleAdjustmentValue.getScaleAdjust(topLeft.y) && q <= ScaleAdjustmentValue.getScaleAdjust(bottomLeft.y)) {
            return true;
        }
        return false;
    }

    /* A utility function to calculate area of triangle
      formed by (x1, y1) (x2, y2) and (x3, y3) */
    static area(x1: number, y1: number, x2: number, y2: number, x3: number, y3: number): number {
        return Math.abs((x1 * (y2 - y3) + x2 * (y3 - y1) + x3 * (y1 - y2)) / 2.0);
    }

    /* A function to check whether point P(x, y) lies
      inside the triangle formed by A(x1, y1),
      B(x2, y2) and C(x3, y3) */
    static isInside(x1: number, y1: number, x2: number, y2: number, x3: number, y3: number, x: number, y: number): boolean {
        /* Calculate area of triangle ABC */
        const A = Statics.area(x1, y1, x2, y2, x3, y3);

        /* Calculate area of triangle PBC */
        const A1 = Statics.area(x, y, x2, y2, x3, y3);

        /* Calculate area of triangle PAC */
        const A2 = Statics.area(x1, y1, x, y, x3, y3);

        /* Calculate area of triangle PAB */
        const A3 = Statics.area(x1, y1, x2, y2, x, y);

        /* Check if sum of A1, A2 and A3 is same as A */
        return (A == A1 + A2 + A3);
    }
}
